import {
  motion,
  MotionStyle,
  useTransform,
  useViewportScroll,
} from "framer-motion";
import React from "react";
import { FadeIn } from "./Transitions/SlideUp";

interface ScrollOpacityOptions {
  input: number[];
  output: number[];
}

interface ScrollYOptions {
  input: number[];
  output: number[];
}

interface FadeInOptions {
  fadeTension?: number;
  fadeDelay?: number;
}

interface Props {
  fadeIn?: FadeInOptions;
  scrollY?: ScrollYOptions;
  scrollOpacity?: ScrollOpacityOptions;
}

export const AnimatedText: React.FC<Props> = (props) => {
  const { scrollY } = useViewportScroll();

  const y = useTransform(
    scrollY,
    props.scrollY?.input || [0, 0],
    props.scrollY?.output || [0, 0]
  );

  const opacity = useTransform(
    scrollY,
    props.scrollOpacity?.input || [1, 1],
    props.scrollOpacity?.output || [1, 1]
  );

  const styleOptions: MotionStyle = {
    ...(props.scrollY && { translateY: y }),
    ...(props.scrollOpacity && { ["opacity" as any]: opacity }),
  };

  return (
    <motion.div style={styleOptions}>
      {props.fadeIn ? (
        <FadeIn
          tension={props.fadeIn.fadeTension}
          delay={props.fadeIn.fadeDelay}
        >
          {props.children}
        </FadeIn>
      ) : (
        <>{props.children}</>
      )}
    </motion.div>
  );
};
